__turbopack_context__.v({
  "body": "kNMPeq_body",
  "close": "kNMPeq_close",
  "description": "kNMPeq_description",
  "grabber": "kNMPeq_grabber",
  "grabberBar": "kNMPeq_grabberBar",
  "headRow": "kNMPeq_headRow",
  "headText": "kNMPeq_headText",
  "header": "kNMPeq_header",
  "overlay": "kNMPeq_overlay",
  "sheet": "kNMPeq_sheet",
  "srOnly": "kNMPeq_srOnly",
  "title": "kNMPeq_title",
});
